module.controller('cameraFormCntrl', function ($location, sharedService, $document, esb, xmppAuth, services, $scope, $mdDialog, $window, theme, cryptool) {
  var xmpp_domain = cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
  var xmppUser = $window.sessionStorage.getItem('userXmpp');
  var imageCapture;
  var snapshotBlob;
  var data = sharedService.getData();
  $scope.data = JSON.parse($window.localStorage.getItem("metadataObj"));
  $scope.theme = theme.getTheme();
  $scope.mask = $scope.data.constraints.mask;


  $scope.needMask = true;
  $scope.maskLandscape = false;
  if($location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
                            && $location.search().user_teller_agent!='undefined' && ($window.navigator.userAgent=== 'commerce-mobile' ||
                             ($location.search().mode!=null && $location.search().mode === 'asesorweb') )){
                            
                            }
  var mobileAndTabletCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };
  

  function positionUpdate(metadataObj, showLockMessage) {

    navigator.geolocation.getCurrentPosition(
      function (position) {
        $window.localStorage.setItem("locationPermission", "true");
         
        $scope.latitude = position.coords.latitude;
        $scope.longitude = position.coords.longitude;  
      },
      function (err) {

        switch (err.code) {
          // PERMISSION_DENIED
          case 1:
            console.log('Permission denied')

            if (showLockMessage) {             
              var contentMessage = (metadataObj.instruction && metadataObj.instruction.gps && metadataObj.instruction.gps.permissionContent || "" )   + " <br> Para activar los permisos necesarios, puede ver las instrucciones <a href='https://www.youtube.com/watch?v=_JF3Sx8i7qk&amp;ab_channel=4toldfintech' target=\"_blank\">aqu&iacute;</a>";
  
              var confirm = $mdDialog.confirm()
                .title(metadataObj.instruction.gps.permissionTitle || "Activar GPS")
                .htmlContent(contentMessage)
                .ariaLabel('Lucky day')
                .ok(metadataObj.instruction && metadataObj.instruction.gps && metadataObj.instruction.gps.permissionAccept || "Aceptar");
              
                $mdDialog.show(confirm).then(function () {

                if (!$window.localStorage.getItem("locationPermission") || $window.localStorage.getItem("locationPermission") == 'lock') {
                  positionUpdate(metadataObj, true, metadataObj.instruction.gps.permissionError);
                }

              }, function () {

              });

            }
            else {

              if ($window.localStorage.getItem("locationPermission") == 'lock') {
                $mdDialog.cancel();
                if (showLockMessage)
                  showAlert(metadataObj.instruction.gps.permissionError || "Error al obtener la ubicacion, por favor intente nuevamente.");
              }
              else {
                $mdDialog.cancel();
                if (!notGrantedLocationQuestion)
                  positionUpdate(metadataObj, true);

              }
            } { }
            break
          // POSITION_UNAVAILABLE
          case 2:
            console.log('Permission allowed, location disabled')
            break
          // TIMEOUT
          case 3:
            console.log('Permission allowed, timeout reached')
            break
        }
        $window.localStorage.setItem("locationPermission", "lock");

      }
    );
  }
  $scope.latitude = 0.0;
  $scope.longitude = 0.0;   
  var showAlert = function (message) {
    $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(false)
        .textContent(message)
        .ok('Ok')
        .ariaLabel('Alert Dialog')
    ).then(function () {
      if (document.getElementById("inputSimple"))
        document.getElementById("inputSimple").focus();
    })
  };
 
  positionUpdate($scope.data, true, null); 


  navigator.mediaDevices.enumerateDevices().then(gotDevices).then(start).catch(handleError);
  $scope.mobile = mobileAndTabletCheck();
  if($window.navigator.userAgent=== 'commerce-mobile') {
    $scope.mobile = true;
  }
  var currentWidth = 480;
  var currentHeight = 320;
  if($scope.mobile) {
    currentWidth = 320;
    currentHeight = 480;
  }

  if ('ImageCapture' in window) {
    $scope.hasImageCapture = false;
  } else {
    $scope.hasImageCapture = false;
  }
  $scope.stopCamera= function(){
    if ($window.stream) {
      $window.stream.getTracks().forEach(track => {
        track.stop();
      });
    }
  }
  
  function getTemplate(docType) {

    var width = currentWidth; 
    //var width = 320;
    var height = video.videoHeight;
    //PE.DNI.FRONT
    var templates = {};
    templates["PE.DNI.FRONT"] = {};
    templates["PE.DNI.FRONT"].rectangles = [];
    templates["PE.DNI.FRONT"].width = $scope.maskLandscape ? 720 : 1280;
    templates["PE.DNI.FRONT"].height = 720;
    var arw = width / templates["PE.DNI.FRONT"].width;
    templates["PE.DNI.FRONT"].frameWidth = arw * 990;
    templates["PE.DNI.FRONT"].frameHeight = arw * 610;
    var rectangle = {};
    rectangle.width = arw * 990;
    rectangle.height = arw * 610;
    rectangle.marginLeft = arw * 160;
    rectangle.marginTop = arw * 65;
    templates["PE.DNI.FRONT"].rectangles.push(rectangle);
    rectangle = {};
    rectangle.width = arw * 230;
    rectangle.height = arw * 320;
    rectangle.marginLeft = arw * 190;
    rectangle.marginTop = arw * 130;
    templates["PE.DNI.FRONT"].rectangles.push(rectangle);
    rectangle = {};
    rectangle.width = arw * 950;
    rectangle.height = arw * 160;
    rectangle.marginLeft = arw * 178;
    rectangle.marginTop = arw * 486;
    templates["PE.DNI.FRONT"].rectangles.push(rectangle);

    // PE.DNI.BACK
    templates["PE.DNI.BACK"] = {};
    templates["PE.DNI.BACK"].rectangles = [];
    templates["PE.DNI.BACK"].width = $scope.maskLandscape ? 720 : 1280;
    templates["PE.DNI.BACK"].height = 720;
    var arw = width / templates["PE.DNI.BACK"].width;
    templates["PE.DNI.BACK"].frameWidth = arw * 990;
    templates["PE.DNI.BACK"].frameHeight = arw * 610;
    var rectangle = {};
    rectangle.width = arw * 990;
    rectangle.height = arw * 610;
    rectangle.marginLeft = arw * 160;
    rectangle.marginTop = arw * 65;
    templates["PE.DNI.BACK"].rectangles.push(rectangle);
    rectangle = {};
    rectangle.width = arw * 192;
    rectangle.height = arw * 216;
    rectangle.marginLeft = arw * 915;
    rectangle.marginTop = arw * 92;
    templates["PE.DNI.BACK"].rectangles.push(rectangle);
    rectangle = {};
    rectangle.width = arw * 704;
    rectangle.height = arw * 160;
    rectangle.marginLeft = arw * 221;
    rectangle.marginTop = arw * 472;
    templates["PE.DNI.BACK"].rectangles.push(rectangle); 
 
    
    // PE.DNI_CHIP.FRONT
    templates["PE.DNI_CHIP.FRONT"] = {};
    templates["PE.DNI_CHIP.FRONT"].rectangles = [];
    templates["PE.DNI_CHIP.FRONT"].width = $scope.maskLandscape ? 720 : 1280;
    templates["PE.DNI_CHIP.FRONT"].height = 720;
    var arw = width / templates["PE.DNI_CHIP.FRONT"].width;
    templates["PE.DNI_CHIP.FRONT"].frameWidth = arw * 990;
    templates["PE.DNI_CHIP.FRONT"].frameHeight = arw * 610;
    var rectangle = {};
    rectangle.width = arw * 990;
    rectangle.height = arw * 610;
    rectangle.marginLeft = arw * 160;
    rectangle.marginTop = arw * 65;
    templates["PE.DNI_CHIP.FRONT"].rectangles.push(rectangle);
    rectangle = {};
    rectangle.width = arw * 85;
    rectangle.height = arw * 85;
    rectangle.marginLeft = arw * 200;
    rectangle.marginTop = arw * 90;
    templates["PE.DNI_CHIP.FRONT"].rectangles.push(rectangle);
 

    // PE.DNI_CHIP.BACK
    templates["PE.DNI_CHIP.BACK"] = {};
    templates["PE.DNI_CHIP.BACK"].rectangles = [];
    templates["PE.DNI_CHIP.BACK"].width = $scope.maskLandscape ? 720 : 1280;
    templates["PE.DNI_CHIP.BACK"].height = 720;
    var arw = width / templates["PE.DNI_CHIP.BACK"].width;
    templates["PE.DNI_CHIP.BACK"].frameWidth = arw * 990;
    templates["PE.DNI_CHIP.BACK"].frameHeight = arw * 610;
    var rectangle = {};
    rectangle.width = arw * 990;
    rectangle.height = arw * 610;
    rectangle.marginLeft = arw * 160;
    rectangle.marginTop = arw * 65;
 
    templates["PE.DNI_CHIP.BACK"].rectangles.push(rectangle);
    rectangle = {};
    rectangle.width = arw * 922;
    rectangle.height = arw * 184;
    rectangle.marginLeft = arw * 194;
    rectangle.marginTop = arw * 437;
    templates["PE.DNI_CHIP.BACK"].rectangles.push(rectangle); 

    
    return  templates[docType];


  }

  function drawTemplate() {
    var templateMaskCanvas = document.querySelector('#templateMask');
    if(!templateMaskCanvas) return;

    const video = document.querySelector('video');
    var width = currentWidth;
    var height = currentHeight;
    if ($scope.maskLandscape) {
      width = 320;
      height = 480;
    }     
    templateMaskCanvas.width = currentWidth;
    templateMaskCanvas.height = currentHeight;     
    var ctx = templateMaskCanvas.getContext('2d');
    ctx.clearRect(0, 0, width, height); 
    var img = document.getElementById('mask1')
    if($scope.mobile)
      img = document.getElementById('mask2')   
        
     
    video.style.width = currentWidth + "px";  
    var t = getTemplate($scope.data.constraints.docType);
    if (t) {
      if ($scope.maskLandscape) { 
        if( !$scope.mask){
          ctx.translate(t.frameWidth - 100, t.frameHeight - 320);
          ctx.rotate(90 * Math.PI / 180);
        }
      } 
      for (f of t.rectangles) {
        ctx.beginPath();
        ctx.lineWidth = "2";
        ctx.strokeStyle = "white";
        ctx.rect(f.marginLeft, f.marginTop, f.width, f.height);
        ctx.stroke();
      }
    } else {
      var width = currentWidth; 
      var height = video.videoHeight;
      var fwidth = $scope.maskLandscape ? 720 : 1280;
      var fheight = 720;
      var arw = width / fwidth;
      var frameWidth = arw * 990;
      var frameHeight = arw * 610;
      if ($scope.maskLandscape) { 
        if( !$scope.mask){
             ctx.translate(frameWidth - 100, frameHeight - 320);
             ctx.rotate(90 * Math.PI / 180);
       }
         
      } 
    }
    if( $scope.mask){
      if ($scope.maskLandscape) { 
        ctx.drawImage(img, 0, 0, currentWidth, currentHeight);  
      } else {
        ctx.drawImage(img, 0, 0, currentWidth, currentHeight);  
      }
    }
    ctx.restore();
  }

  function gotDevices(deviceInfos) {
    const audioInputSelect = document.querySelector('select#audioSource');
    const audioOutputSelect = document.querySelector('select#audioOutput');
    const videoSelect = document.querySelector('select#videoSource');
    const selectors = [audioInputSelect, audioOutputSelect, videoSelect];
    const values = selectors.map(select => select.value);
    selectors.forEach(select => {
      while (select.firstChild) {
        select.removeChild(select.firstChild);
      }
    });
    for (let i = 0; i !== deviceInfos.length; ++i) {
      const deviceInfo = deviceInfos[i];
      const option = document.createElement('option');
      option.value = deviceInfo.deviceId;
      if (deviceInfo.kind === 'audioinput') {
        option.text = deviceInfo.label || `microphone ${audioInputSelect.length + 1}`;
        audioInputSelect.appendChild(option);
      } else if (deviceInfo.kind === 'audiooutput') {
        option.text = deviceInfo.label || `speaker ${audioOutputSelect.length + 1}`;
        audioOutputSelect.appendChild(option);
      } else if (deviceInfo.kind === 'videoinput') {
        option.text = deviceInfo.label || `camera ${videoSelect.length + 1}`;
        videoSelect.appendChild(option);
        console.log(option.text + "---" + option.value);
      } else {
        console.log('Some other kind of source/device: ', deviceInfo);
      }
    }
    selectors.forEach((select, selectorIndex) => {
      if (Array.prototype.slice.call(select.childNodes).some(n => n.value === values[selectorIndex])) {
        select.value = values[selectorIndex];
      }
    });
  }

  function gotStream(stream) {
    const videoElement = document.querySelector('video');
    window.stream = stream; // make stream available to console
    videoElement.srcObject = stream;
    // Refresh button list in case labels have become available
    return navigator.mediaDevices.enumerateDevices();
  }

  function handleError(error) {
    console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
  }
  $scope.isStarting = true; 
  function start() {
    started();
    if (window.stream) {
      
      window.stream.getTracks().forEach(track => {
        track.stop();
      });
    } 

    const videoSelect = document.querySelector('select#videoSource');
    const videoSource = videoSelect.value;
    const constraints = {
      audio: false,
      video: {
        deviceId: videoSource ? {
          exact: videoSource
        } : undefined,
        width: 720,
        height: 480
      }
    };

    navigator.mediaDevices.getUserMedia(constraints).then(gotStream).then(gotDevices).catch(handleError);
  }

 function started() {
      setTimeout(function () {
        $scope.isStarting = false;
      }, 2000);      
  }
  
  let cameraIndex = 1;
  function changeCameraClick() {
   
    const videoSelect = document.querySelector('select#videoSource');

    const options = videoSelect.options;
    const videoSource = options[videoSelect.selectedIndex];
    if (videoSelect.length == 1) {
      return;
    }

    if (navigator.userAgent === 'commerce-mobile') {
      if (cameraIndex == videoSelect.length) {
        cameraIndex = 0;
        $scope.maskLandscape = false;
      } else {
        $scope.maskLandscape = true;
      }

      videoSelect.selectedIndex = cameraIndex;
      cameraIndex = cameraIndex + 1;
      start();


    } else {

      const typeCameraSearch = videoSource.text.toLowerCase().search("front") === -1 ? "front" : "back";

      for (var i = 0; i < videoSelect.length; i++) {

        var cam = "frontal";
        $scope.maskLandscape = false;
        if (typeCameraSearch != "front") {
          cam = "trasera";
          $scope.maskLandscape = true;
         

        }
        drawTemplate()
        if (videoSelect[i].text.toLowerCase().search(typeCameraSearch) != -1 || videoSelect[i].text.toLowerCase().search(cam) != -1) {
          videoSelect.selectedIndex = i;
          start();
          return;
        }
      }

    }


  }
 
  $scope.getVideoSize = function () {
    //video.style.width = "480px";
    const btnChangeCamera = document.querySelector('button#changeCamera');
    btnChangeCamera.onclick = changeCameraClick;
    drawTemplate();
    mediaStream = document.querySelector('video').srcObject;
    const track = mediaStream.getVideoTracks()[0];
    if ($scope.hasImageCapture)
      imageCapture = new ImageCapture(track);

  };

  $scope.canvas = document.createElement('canvas');
  $scope.makeSnapshotV2 = async function () {
    
    if (!$scope.hasImageCapture) {
      $scope.makeSnapshotV2a();
      return;
    }
    $scope.snapshot = "ok";
    $scope.snapshot2 = "ok";
    required_width = 200
    required_height = 200
    const {
      imageWidth,
      imageHeight
    } = await imageCapture.getPhotoCapabilities();
    const width = setInRange(required_width, imageWidth);
    const height = setInRange(required_height, imageHeight);
    global_width = width;
    global_height = height;
    const photoSettings = (width && height) ? {
      imageWidth: width,
      imageHeight: height
    } : null;

    imageCapture.takePhoto(photoSettings)
      .then(function (blob) {
        snapshotBlob = blob;
        const img = document.querySelector('#snapshot');
        url = URL.createObjectURL(blob);
        loadImage(
          url,
          function (canvas) {
            $scope.canvas = canvas;
            img.src = canvas.toDataURL();
            $scope.snapshotData = img.src;
          }, {
            maxWidth: global_width,
            maxHeight: required_height,
            orientation: true,
            canvas: true
          }
        )
        /** NEW ***/
      })
      .catch(function (error) {
        console.log(error)
      });
  }

  function setInRange(value, range) {
    if (!range) return NaN;
    let x = Math.min(range.max, Math.max(range.min, value));
    x = Math.round(x / range.step) * range.step;
    return x;
  }

  $scope.closeDialog = function () {
    $mdDialog.cancel();
    stopCamera();
  }
 
  $scope.makeSnapshotV2a = function () {
    const video = document.getElementById('video') || document.getElementById('videoImage');
    $scope.snapshot1 = "ok";
    $scope.snapshot2 = "ok";
    var patCanvas = document.querySelector('#snapshot1');
    if (!patCanvas) return;
    patCanvas.width = video.videoWidth;
    patCanvas.height = video.videoHeight;
    patCanvas.getContext('2d').drawImage(video, 0, 0, patCanvas.width, patCanvas.height);
  }

  $scope.changeCamera = function () {
    const videoSelect = $document.find('select.videoSource');
    const videoSource = videoSelect.value;

    console.log(videoSelect.length);
    if (videoSelect.length == 1) {
      return;
    }
    const typeCameraSearch = videoSource.search("front") === -1 ? "front" : "back";

    alert(typeCameraSearch);
    for (i = 0; i < videoSelect.length; i++) {
      if (videoSelect[i].value.search(typeCameraSearch) != -1) {
        videoSelect.selectedIndex = i;
      }
    }
  }

  function stopCamera() {
    if ($window.stream) {
      $window.stream.getTracks().forEach(track => {
        track.stop();
      });
    }
  }


  var _video = null,
    patData = null;

  $scope.patOpts = {
    x: 0,
    y: 0,
    w: 25,
    h: 25
  };

  $scope.channel = {
    // the fields below are all optional
    videoHeight: 1000,
    videoWidth: 600,
    video: null // Will reference the video element on success
  };

  $scope.webcamError = false;
  $scope.onError = function (err) {
    $scope.error = true;
    console.log("here error");
    $scope.$apply(
      function () {
        $scope.webcamError = err;
      }
    );
  };

  $scope.onSuccess = function () {
    // The video element contains the captured camera data
    _video = $scope.channel.video;
    $scope.$apply(function () {
      $scope.patOpts.w = _video.width;
      $scope.patOpts.h = _video.height;
      //$scope.showDemos = true;
    });
  };

  $scope.onStream = function (stream) {
    // You could do something manually with the stream.
  };

  $scope.makeSnapshot = function () {
    if (_video) {
      $scope.snapshot = "ok";
      var patCanvas = document.querySelector('#snapshot');
      if (!patCanvas) return;
      patCanvas.width = _video.width;
      patCanvas.height = _video.height;
      var ctxPat = patCanvas.getContext('2d');
      var idata = getVideoData($scope.patOpts.x, $scope.patOpts.y, $scope.patOpts.w, $scope.patOpts.h);
      ctxPat.putImageData(idata, 0, 0);
      sendSnapshotToServer(patCanvas.toDataURL());
      patData = idata;
    }
  };
  
  $scope.sendPicture = function () {

    if (!$scope.hasImageCapture) {
      $scope.sendPicture2();
      return;
    }

    $scope.progressCircular = "ok";
    $scope.canvas.toBlob(function (blob) {
      var blobUrl = URL.createObjectURL(blob);
      const payload = new FormData();
      var format = blob.type.split("/");
      payload.append('type', data.id);
      payload.append('fileExtension', format[1]);
      payload.append('latitude',  $scope.latitude);
      payload.append('longitude',  $scope.longitude);
      payload.append('file', blob, 'filename.png');

      services.user.userServices('bearer ' + $window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function (response, event) {
        $scope.progressCircular = undefined;
        if (response.data.url) {
          var message = {
            text: response.data.url,
            url: blobUrl,
            type: "sent",
            layout: "end",
            format: format[1],
            typeDocument: "Image"
          }
          var value = "{\"code\":\"1\",\"format\":\"" + format[1] + "\",\"imageCapture\":\"mandatory\",\"imageType\":\"externalPaymentReceipt\",\"type\":\"Image\",\"url\":\"" + esb + "/security" + response.data.url + "\"}";
          xmppAuth.Chat.sendMessageImage(xmppUser + "@" + xmpp_domain, "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, message, value);
          $scope.metadataObj = undefined;
        }
        $scope.closeDialog();
      });
    });
  }

  $scope.sendPicture1 = function () {
    $scope.progressCircular = "ok";
    var blob = snapshotBlob;
    var blobUrl = $scope.snapshotData
    const payload = new FormData();
    var format = blob.type.split("/");
    payload.append('type', data.id);
    payload.append('fileExtension', format[1]); 
    payload.append('latitude',  $scope.latitude);
    payload.append('longitude',  $scope.longitude);
    payload.append('file', blob, 'filename.png');

    services.user.userServices('bearer ' + $window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function (response, event) {
      $scope.progressCircular = undefined;
      if (response.data.url) {
        var message = {
          text: response.data.url,
          url: blobUrl,
          type: "sent",
          layout: "end",
          format: format[1],
          typeDocument: "Image"
        }
        var value = "{\"code\":\"1\",\"format\":\"" + format[1] + "\",\"imageCapture\":\"mandatory\",\"imageType\":\"externalPaymentReceipt\",\"type\":\"Image\",\"url\":\"" + esb + "/security" + response.data.url + "\"}";
        xmppAuth.Chat.sendMessageImage(xmppUser + "@" + xmpp_domain, "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, message, value);
        $scope.metadataObj = undefined;
      }
      $scope.closeDialog();
    });
  }


  $scope.sendPicture2 = function(){
    $scope.errorMessage = false
    $scope.progressCircular = "ok";
    const canvasImg = document.getElementById('snapshot1');
     canvasImg.toBlob(function(blob) {
       var blobUrl = URL.createObjectURL(blob);
       const payload = new FormData();
       var format = blob.type.split("/");
       payload.append('type', data.id);
       payload.append('fileExtension', format[1]);
       payload.append('latitude',  $scope.latitude);
       payload.append('longitude',  $scope.longitude);
       payload.append('file', blob, 'filename.png');

       services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
         $scope.progressCircular = undefined;
         if(response.code == 1) {
            if(response.data.url) {
              var ext = format[1];   
              var answer = {value: response.data.url, extension: ext, id: data.id, skipId: null}             
              $scope.metadataObj = undefined;
              $scope.stopCamera();
              $mdDialog.hide(answer); 
            }
         } else { 
            $scope.errorMessage = response.message
         }
     });
     });
  }
  
  $scope.sendAnswer = function () {
    $scope.progressCircular = "ok";
    const canvasImg = document.getElementById('snapshot1');
    canvasImg.toBlob(function (blob) {
      var blobUrl = URL.createObjectURL(blob);
      const payload = new FormData();
      var format = blob.type.split("/");
      var type = "IMAGE_CAPTURE"
      if (data)
        type = data.id
      payload.append('type', type);
      payload.append('fileExtension', format[1]);
      payload.append('latitude',  $scope.latitude);
      payload.append('longitude',  $scope.longitude);
      payload.append('file', blob, 'filename.png');

       services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function(response, event){
         $scope.progressCircular = undefined;        
         if (response.data.url) {
           var data = {};
           data.url = response.data.url
           data.fileName = blobUrl;
           $mdDialog.hide(data);
           stopCamera();
         }
     });
     }); 
  }

  /**
   * Redirect the browser to the URL given.
   * Used to download the image by passing a dataURL string
   */

  $scope.downloadSnapshot = function downloadSnapshot(dataURL) {
    window.location.href = dataURL;
  };

  var getVideoData = function getVideoData(x, y, w, h) {
    var hiddenCanvas = document.createElement('canvas');
    hiddenCanvas.width = _video.width;
    hiddenCanvas.height = _video.height;
    var ctx = hiddenCanvas.getContext('2d');
    ctx.drawImage(_video, 0, 0, _video.width, _video.height);
    return ctx.getImageData(x, y, w, h);
  };


  var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
    $scope.snapshotData = imgBase64;
  };

});
